unit systemsetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.DB, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.TMSWEBCustomComponent, WEBLib.TMSWEBStateManager,
  WEBLib.TMSWEBResponsiveManager, WEBLib.DBCtrls, WEBLib.ComCtrls;

type
  TfrmSystemSetup = class(TWebForm)
    XDataWebDataSet1: TXDataWebDataSet;
    WebDataSource1: TWebDataSource;
    WebPanel2: TWebPanel;
    WebLabel1: TWebLabel;
    WebResponsiveManager1: TWebResponsiveManager;
    WebPageControl1: TWebPageControl;
    WebPageControl1Sheet1: TWebTabSheet;
    WebPageControl1Sheet2: TWebTabSheet;
    WebPageControl1Sheet3: TWebTabSheet;
    WebPanel1: TWebPanel;
    WebLabel2: TWebLabel;
    WebImageControl1: TWebImageControl;
    WebLabel3: TWebLabel;
    WebLabel4: TWebLabel;
    WebDBEdit1: TWebDBEdit;
    WebDBEdit12: TWebDBEdit;
    WebDBEdit13: TWebDBEdit;
    WebDBEdit14: TWebDBEdit;
    WebDBEdit15: TWebDBEdit;
    WebDBEdit16: TWebDBEdit;
    WebDBEdit17: TWebDBEdit;
    WebDBEdit18: TWebDBEdit;
    WebDBEdit19: TWebDBEdit;
    WebDBEdit20: TWebDBEdit;
    WebDBEdit21: TWebDBEdit;
    WebPanel3: TWebPanel;
    WebDBEdit2: TWebDBEdit;
    WebDBEdit3: TWebDBEdit;
    WebDBEdit4: TWebDBEdit;
    WebDBEdit5: TWebDBEdit;
    WebDBEdit6: TWebDBEdit;
    WebDBEdit7: TWebDBEdit;
    WebDBEdit8: TWebDBEdit;
    WebDBEdit9: TWebDBEdit;
    WebDBLookupComboBox1: TWebDBLookupComboBox;
    WebDBLookupComboBox2: TWebDBLookupComboBox;
    WebDBLookupComboBox3: TWebDBLookupComboBox;
    WebDBLookupComboBox4: TWebDBLookupComboBox;
    WebDBLookupComboBox5: TWebDBLookupComboBox;
    WebDBLookupComboBox6: TWebDBLookupComboBox;
    WebPanel4: TWebPanel;
    WebDBEdit10: TWebDBEdit;
    WebDBEdit11: TWebDBEdit;
    WebDBEdit22: TWebDBEdit;
    WebDBEdit24: TWebDBEdit;
    WebLabel6: TWebLabel;
    WebDBCheckBox1: TWebDBCheckBox;
  private
    { Private declarations }
  public
    { Public declarations }
  end;

var
  frmSystemSetup: TfrmSystemSetup;

implementation

{$R *.dfm}

uses
 stfmssystem.connection;

end.
